import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MilestoneTemplateRequestDto } from 'src/api/FiretrolApiClient';
import { milestoneTemplateApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateMilestoneTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => milestoneTemplateApiClient.createTemplate(),
    onSettled: () => invalidateFor('milestoneTemplate.save', qc),
  });
}

export function useUpdateMilestoneTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      templateId,
      request,
    }: {
      templateId: string;
      request: MilestoneTemplateRequestDto;
    }) => milestoneTemplateApiClient.updateTemplate(templateId, request),
    onSettled: () => invalidateFor('milestoneTemplate.save', qc),
  });
}

export function useDeleteMilestoneTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (templateId: string) =>
      milestoneTemplateApiClient.removeTemplate(templateId),
    onSettled: () => invalidateFor('milestoneTemplate.delete', qc),
  });
}
